<template>
    <div>
        <span class="title text-center" style="font-weight: bold">Download your free LUTs</span>
        <span class="description">
                Your copy of our free LUTs is here. Click the button below to begin download.
            </span>
        <v-btn @click="download" :disabled="isDownloading" depressed class="modal-btn --primary">
            Download free LUTs
        </v-btn>
        <span @click="nextOnboardingStep" class="ml-auto"
              style="text-decoration: underline; cursor: pointer; font-weight: bold; font-size: 14px">Close</span>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            isDownloading: false
        }
    },

    methods: {
        async download() {
            this.isDownloading = true;
            await this.$store.dispatch("Loader/showProgressBar", "indeterminate");
            const downloadFreeLutsResponse = await this.$store.dispatch('Files/downloadFreeLutsPackage');

            axios({
                url: downloadFreeLutsResponse.url,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                let fileName = downloadFreeLutsResponse.url.substring(downloadFreeLutsResponse.url.lastIndexOf("/") + 1).split("?")[0];
                let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                let fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', fileName);
                document.body.appendChild(fileLink);

                fileLink.click();
                fileLink.remove();
                window.URL.revokeObjectURL(fileURL);
                this.$store.dispatch("Loader/showProgressBar", false);
                this.isDownloading = false;
            });
        },

        nextOnboardingStep() {
            this.$store.dispatch("UI/setStartTipsStep", 'complete');
        }
    }
}
</script>

<style lang="scss" scoped>
div {
	position: absolute;
	z-index: 20;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	max-width: 570px;
	background: white;
	padding: 25px 50px !important;
	border-radius: var(--box-rounding);
	font-size: 1rem;
	color: #444444;
	display: flex;
	flex-direction: column;
	gap: 20px;

	span {
		line-height: 1.3;
		&.title {
			font-family: Poppins !important;
		}
	}

	.modal-btn {
		margin-left: auto;
		margin-right: auto;
		background: var(--primary) !important;
	}
}
</style>